/**
 * LegalPage - renders any legal page from /lib/legal.js
 */
import { useLocation, Navigate } from "react-router-dom";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { LEGAL_PAGES } from "@/lib/legal";
import { Calendar } from "lucide-react";

const PATH_TO_KEY = {
    "/termos": "termos",
    "/privacidade": "privacidade",
    "/sla": "sla",
    "/reembolso": "reembolso",
    "/aviso-legal": "aviso_legal",
};

export default function LegalPage() {
    const { pathname } = useLocation();
    const key = PATH_TO_KEY[pathname];
    const page = key ? LEGAL_PAGES[key] : null;
    if (!page) return <Navigate to="/" replace />;

    const slug = pathname.replace("/", "");

    return (
        <div className="py-12 sm:py-16" data-testid={`legal-page-${slug}`}>
            <div className="mx-auto w-full max-w-3xl px-4 sm:px-6 lg:px-8">
                <Badge variant="outline" className="mb-3 border-[#6B21D9]/30 bg-[#6B21D9]/10 text-[#6B21D9] gap-1">
                    <Calendar className="h-3 w-3" /> {page.last_update}
                </Badge>
                <h1 className="font-display text-3xl sm:text-4xl font-semibold tracking-tight">
                    {page.title}
                </h1>
                <p className="mt-2 text-muted-foreground">{page.subtitle}</p>
                <Card className="mt-8 p-6 sm:p-8 rounded-2xl bg-card border-border">
                    <div className="prose prose-sm max-w-none">
                        {page.body.map((section, i) => (
                            <div key={i} className="mb-6 last:mb-0">
                                <h2 className="font-display text-lg font-semibold tracking-tight">{section.heading}</h2>
                                <p className="mt-2 text-sm leading-relaxed text-muted-foreground whitespace-pre-line">
                                    {section.text}
                                </p>
                            </div>
                        ))}
                    </div>
                </Card>
                <p className="mt-6 text-xs text-muted-foreground text-center">
                    Em caso de dúvidas, contacte-nos em{" "}
                    <a href="mailto:geral@mesafa.ao" className="text-[#6B21D9] hover:underline">
                        geral@mesafa.ao
                    </a>
                </p>
            </div>
        </div>
    );
}
